var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4615 0.976562H2.74094C1.66167 0.976562 0.76212 1.86537 1.02876 2.91046C1.31262 4.01795 1.83553 5.04985 2.56076 5.93369C3.28598 6.81752 4.19593 7.53184 5.22668 8.02648C6.03051 8.41131 6.64779 9.16728 6.64779 10.058V16.0004C6.64788 16.1668 6.6905 16.3304 6.77159 16.4758C6.85268 16.6211 6.96956 16.7433 7.11114 16.8308C7.25272 16.9182 7.41431 16.9681 7.58056 16.9756C7.74682 16.9831 7.91223 16.9479 8.0611 16.8736L10.0145 15.8968C10.1767 15.8158 10.3132 15.6912 10.4086 15.5369C10.504 15.3827 10.5546 15.205 10.5546 15.0237V10.058C10.5546 9.16728 11.1719 8.41131 11.9748 8.02648C13.0059 7.53213 13.9163 6.81792 14.6419 5.93406C15.3675 5.05021 15.8906 4.01816 16.1747 2.91046C16.4393 1.86537 15.5388 0.976562 14.4615 0.976562Z",
    stroke: "#CD2A3F",
    strokeWidth: 1.95343
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconNew);
export default __webpack_public_path__ + "static/media/filterIconNew.3939ffd0655e0ccce685da7f11226474.svg";
export { ForwardRef as ReactComponent };